import { get, type APIResponse } from './base-fetch';

export type CompanyFundings =
  APIResponse<'/api/v4/organization/{organizationId}/fundings'>;

export const fetchCompanyFundings = async (
  organizationId: string,
): Promise<CompanyFundings> =>
  get<CompanyFundings>(`/v4/organization/${organizationId}/fundings`);
